var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/archive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/archive_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 18.2812H15C13.7063 18.2812 12.6562 19.3312 12.6562 20.625V22.5938C12.7125 22.575 12.75 22.5563 12.8062 22.5375C13.0312 22.425 13.275 22.35 13.5188 22.275C13.6313 22.2375 13.7438 22.2 13.875 22.1625C14.25 22.0875 14.625 22.0312 15.0188 22.0312H30.0188C30.4125 22.0312 30.7875 22.0875 31.1625 22.1625C31.275 22.1812 31.3875 22.2375 31.5188 22.275C31.7625 22.35 32.0063 22.425 32.2313 22.5375C32.2875 22.5563 32.3438 22.575 32.3813 22.5938V20.625C32.3438 19.3312 31.2938 18.2812 30 18.2812Z",
    fill: "url(#paint0_linear_242_1618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 24.8438H15C13.7062 24.8438 12.6562 25.8937 12.6562 27.1875V28.125H17.8125C18.5813 28.125 19.2188 28.7625 19.2188 29.5312C19.2188 31.3313 20.7 32.8125 22.5 32.8125C24.3 32.8125 25.7812 31.3313 25.7812 29.5312C25.7812 28.7625 26.4187 28.125 27.1875 28.125H32.3438V27.1875C32.3438 25.8937 31.2938 24.8438 30 24.8438Z",
    fill: "url(#paint1_linear_242_1618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30 12.1875H15C13.7062 12.1875 12.6562 13.2375 12.6562 14.5313V16.05C13.3687 15.6938 14.1562 15.4688 15 15.4688H30C30.8438 15.4688 31.6313 15.6938 32.3438 16.05V14.5313C32.3438 13.2375 31.2938 12.1875 30 12.1875Z",
    fill: "url(#paint2_linear_242_1618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.3563 3.75H14.6438C7.81875 3.75 3.75 7.81875 3.75 14.6438V30.3375C3.75 37.1813 7.81875 41.25 14.6438 41.25H30.3375C37.1625 41.25 41.2313 37.1813 41.2313 30.3563V14.6438C41.25 7.81875 37.1813 3.75 30.3563 3.75ZM35.625 30.9375H33.75H28.425C27.7875 33.6187 25.3688 35.625 22.5 35.625C19.6313 35.625 17.2125 33.6187 16.575 30.9375H11.25H9.375C8.60625 30.9375 7.96875 30.3 7.96875 29.5312C7.96875 28.7625 8.60625 28.125 9.375 28.125H9.84375V27.1875V26.25V20.625V14.5312C9.84375 11.6813 12.15 9.375 15 9.375H30C32.85 9.375 35.1563 11.6813 35.1563 14.5312V20.625V26.25V27.1875V28.125H35.625C36.3938 28.125 37.0313 28.7625 37.0313 29.5312C37.0313 30.3 36.3938 30.9375 35.625 30.9375Z",
    fill: "url(#paint3_linear_242_1618)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_1618",
    x1: 22.5188,
    y1: 18.2812,
    x2: 22.5188,
    y2: 22.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E4FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_242_1618",
    x1: 22.5,
    y1: 24.8438,
    x2: 22.5,
    y2: 32.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E4FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_242_1618",
    x1: 22.5,
    y1: 12.1875,
    x2: 22.5,
    y2: 16.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E4FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_242_1618",
    x1: 22.4907,
    y1: 3.75,
    x2: 22.4907,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E4FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.ff96af40709509f8685c2890775a3419.svg";
export { ForwardRef as ReactComponent };